// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22fgu","label":"styles_label__2IHbj"};